import * as yup from "yup";

export const CatalogoSchema = yup.object().shape({
  name: yup.string().required("Campo requerido"),
});